
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import Pollo from './pollo';
import HouseDrinks from './housedrinks';
import Liquours from './liquours';
import Digestivos from './digestivos';
import ListProducts from './ListProducts';

const fetchImage = async (id) => {
    const imageBlob = await getImage(id);
    if (imageBlob) {
        return URL.createObjectURL(imageBlob.data.blob);
    }
    return null;
};

const Item = React.memo(({ data, onPress, langEng, i18n }) => {
    const [image, setImage] = useState(false);
    useEffect(() => {
        fetchImage(`menu-image-h-${data.id}`).then((url) => {
            if (url) {
                setImage(url);
            }
        });
    }, [data.id]);

    return (
       <div onClick={onPress}  style={{
            backgroundColor: '#612b10', marginBottom: 30, textDecoration: 'none',
            width: '48%',
            maxHeight: 450,
            margin: '0px 0px 15px',
            textAlign: 'left',

            paddingBottom: 20,

            boxSizing: 'border-box',
            position: 'relative',
            borderRadius: 15,
        }}>
            <img src={image} loading="lazy" style={{width: '100%', height: 240, objectFit: 'cover',    borderRadius: 10,}}/>
            <h3 style={
                {  color: '#fff', textTransform: 'uppercase', fontSize: 24, margin: '10px 0 0', textAlign: 'center', fontFamily: 'Noodle' }
                }>

                {/* {data.name} */}
                {langEng ? data.name : translate(i18n.language, data.language, data.name)}

            </h3>

            <div style={{width: '100%', margin: '0 auto'}}>
                <p
                    className='shor-text-one'
                    style={{ fontFamily: "Noodle", fontSize: 18, color: '#fff', textAlign: 'center', margin: 0, textTransform: 'uppercase', fontWeight: '500'}}>

                    {/* {`${data.regular_decription.replace(/\\n/g,'\n')}`} */}
                    {langEng ?
                                `${data.regular_decription.replace(/\\n/g,'\n')}`
                            :
                            `${translateMenu(
                                i18n.language,
                                data.language,
                                data.regular_decription,
                                'regular_decription'
                            )}`
                    }


                </p>
            </div>
        </div>
    );
});

function Index({dishs, setShowListProduct, goHome}) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;
    const [dishs2, setdishs] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showListProduct2, setShowListProduct2] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showPollo, setshowPollo] = useState(false);
    const [showHouseDrinks, setshowHouseDrinks] = useState(false);
    const [showLiquors, setshowLiquors] = useState(false);
    const [showDigestivos, setshowDigestivos] = useState(false);

    const [activeCategory, setActiveCategory] = useState(dishs?.id || null);
    const scrollContainerRef = useRef(null);
    const tabsContainerRef = useRef(null);

    // Categorias que no se muestran como pestaña
    const EXCLUDED_IDS = [1016, 1017, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567];
    // Categorias que abren una pantalla personalizada (no tienen seccion inline)
    const SPECIAL_IDS = [910, 917, 918, 914, 1015];

    // Categorias que SI se renderizan como secciones dentro del scroll
    const inlineCategories = menusData.filter(
        (cat) => !EXCLUDED_IDS.includes(cat.id) && !SPECIAL_IDS.includes(cat.id)
    );

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);


    useEffect(() => {
        if (menus) {


            setIitleCategorie(langEng ?
                dishs.name
                :
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {

            if (item.id === 1015) {
                setBeverages(item);
            }
        });
      }, [menusData]);

    // Baja automaticamente a la categoria que llega seleccionada desde index
    useEffect(() => {
        const targetId = dishs?.id;
        if (targetId && menusData.length > 0) {
            setTimeout(() => {
                const container = scrollContainerRef.current;
                const section = container && container.querySelector(`[data-cat-section="${targetId}"]`);
                if (section && container) {
                    const containerTop = container.getBoundingClientRect().top;
                    const sectionTop = section.getBoundingClientRect().top - containerTop + container.scrollTop;
                    container.scrollTo({ top: sectionTop, behavior: 'smooth' });
                    setActiveCategory(targetId);
                }
            }, 200);
        }
    }, [menusData]);

    // Detecta cual categoria esta arriba mientras se hace scroll
    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container || inlineCategories.length === 0) return;

        let ticking = false;
        const handleScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const containerTop = container.getBoundingClientRect().top;
                let currentId = null;
                inlineCategories.forEach((cat) => {
                    const section = container.querySelector(`[data-cat-section="${cat.id}"]`);
                    if (section) {
                        const sectionTop = section.getBoundingClientRect().top - containerTop;
                        if (sectionTop <= 80) currentId = cat.id;
                    }
                });
                if (currentId !== null) setActiveCategory(currentId);
                ticking = false;
            });
        };

        container.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => container.removeEventListener('scroll', handleScroll);
    }, [menusData]);

    // Centra la pestaña activa en la barra superior
    useEffect(() => {
        if (activeCategory && tabsContainerRef.current) {
            const activeTab = tabsContainerRef.current.querySelector(`[data-cat-id="${activeCategory}"]`);
            if (activeTab) {
                activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
        }
    }, [activeCategory]);

const GoBeverages = () => {
          console.log({Beverages});
         setMenus(Beverages.menus)
    }


    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
            setShowDrinks(true)
        }} showCocktails={ setShowCocktails}  showLamp={ false}   showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>

                <div ref={tabsContainerRef} style={{
                   // backgroundImage: `url(${require('./assets/barra.png')})`,
                    background: '#612b10',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '94%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 30
                }}>
                    {menusData.map((item, key) => {
                             if (!EXCLUDED_IDS.includes(item.id)) {
                                const isActive = activeCategory === item.id;
                                return <div key={key}
                                    data-cat-id={item.id}
                                    style={{
                                    background: isActive ? '#f9e6c8' : '#f9e6c8',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '12px 28px',
                                    borderRadius: 25,
                                    minWidth: 'fit-content',
                                    transition: 'background 0.3s, border 0.3s',
                                    border: isActive ? '3px solid #612b10' : '3px solid transparent',
                            }}
                                    onClick={() => {
                                    if(item.id === 910) {
                                        setshowPollo(true)
                                    } else if (item.id === 917) {
                                        setshowLiquors(true)
                                    } else if (item.id === 918) {
                                        setshowDigestivos(true)
                                    } else if (item.id === 914) {
                                        setshowHouseDrinks(true)
                                    }else if (item.id === 1015) {
                                        setShowDrinks(true)
                                    } else {
                                        // Scroll suave hacia la seccion de la categoria
                                        setActiveCategory(item.id);
                                        const container = scrollContainerRef.current;
                                        const section = container && container.querySelector(`[data-cat-section="${item.id}"]`);
                                        if (section && container) {
                                            const containerTop = container.getBoundingClientRect().top;
                                            const sectionTop = section.getBoundingClientRect().top - containerTop + container.scrollTop;
                                            container.scrollTo({ top: sectionTop, behavior: 'smooth' });
                                        }
                                    }
                                }}
                                >
                                    <p className='shor-text' style={{ color: '#000000', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase',  }}>
{/* {item.name} */}

                                    {langEng ?
                                    `${item.name}`
                                :
                                `${translateMenu(
                                    i18n.language,
                                    item.language,
                                    item.name,
                                    'name'
                                )}`
                                        }
                                    </p>

                            </div>
                            }

                        })}
                </div>

{/*
                <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                    <img src={require('./assets/sidescarnes.png')} style={{width: '100%', height: 120, objectFit: 'contain', borderRadius: 15}} />
                </div> */}
                <div >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        paddingInline: 10

                    }}>
                        {/* <div style={{ width: '45%' , marginTop: 15,}}>
                             <img loop autoPlay muted src={require('./assets/listo.png')}  style={{width: '100%', height: 580, objectFit: 'cover', borderRadius: 15}} />
                        </div> */}
                         <div ref={scrollContainerRef} style={{
                            width: '100%',
                            padding: '0px 0px 100px 0px',
                            maxHeight: 610,
                            overflowY: 'scroll',
                            marginTop: 15,

                        }}>
                            {inlineCategories.map((cat, catKey) => (
                                <div key={catKey} data-cat-section={cat.id} id={`category-section-${cat.id}`}>
                                    <h2 style={{
                                        color: '#612b10',
                                        fontFamily: 'Noodle',
                                        fontSize: 44,
                                        textTransform: 'uppercase',
                                        margin: catKey === 0 ? '0 0 20px' : '50px 0 20px',
                                        paddingBottom: 10,
                                        borderBottom: '2px solid rgba(97,43,16,0.3)',
                                        lineHeight: 1.1,
                                    }}>
                                        {langEng ? cat.name : translateMenu(i18n.language, cat.language, cat.name, 'name')}
                                    </h2>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'flex-start',
                                        gap: '4%',
                                    }}>
                                        {cat.menus && cat.menus.map((item, key) => (
                                            <Item
                                                data={item}
                                                key={key}
                                                langEng={langEng}
                                                i18n={i18n}
                                                onPress={() => [
                                                    setShowDetailProduct(true),
                                                    setDataDish({ dish: item, alldish: cat.menus, currentDish: dishs })
                                                ]}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                    </div>
                    </div>






                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}


                 {showListProduct2 && <ListProducts
                dishs={dishs2}
                setShowListProduct={setShowListProduct2}
            />}

                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                {showPollo && <Pollo setShowHappy={setshowPollo} />}
                {showHouseDrinks && <HouseDrinks setShowHappy={setshowHouseDrinks} />}
                {showLiquors && <Liquours setShowHappy={setshowLiquors} />}
                  {showDigestivos && <Digestivos setShowHappy={setshowDigestivos} />}

            </LayoutContent>
        </div>
    );
}
export default Index;
